import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { FestivalBanner } from "./components/FestivalBanner";
import { Manifesto } from "./components/Manifesto";
import { Explore } from "./components/Explore";
import { Rooms } from "./components/Rooms";
import { FoodMenu } from "./components/FoodMenu";
import { Booking } from "./components/Booking";
import { Platforms } from "./components/Platforms";
import { Directions } from "./components/Directions";
import { Reviews } from "./components/Reviews";
import { Location } from "./components/Location";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="bg-cream font-sans text-ink antialiased" data-testid="app-root">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <FestivalBanner />
          <Rooms />
          <Booking />
          <Manifesto />
          <Explore />
          <FoodMenu />
          <Platforms />
          <Directions />
          <Reviews />
          <Location />
        </main>
        <Footer />
        <WhatsAppFloat />
        <Toaster position="top-center" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
